const CHUNK_RELOAD_FLAG_PREFIX = 'chunk_reload_attempted:';

const buildChunkReloadKey = (routeKey) => `${CHUNK_RELOAD_FLAG_PREFIX}${routeKey}`;

const isChunkLoadError = (error) => {
  const errorName = error?.name || '';
  const errorMessage = error?.message || '';

  return (
    errorName === 'ChunkLoadError'
    || /Loading chunk [\d]+ failed/i.test(errorMessage)
    || /ChunkLoadError/i.test(errorMessage)
  );
};

const lazyWithRetry = async (importer, routeKey) => {
  try {
    const module = await importer();
    sessionStorage.removeItem(buildChunkReloadKey(routeKey));
    return module;
  } catch (error) {
    if (!isChunkLoadError(error)) {
      throw error;
    }

    const reloadKey = buildChunkReloadKey(routeKey);
    const hasRetried = sessionStorage.getItem(reloadKey) === 'true';

    if (!hasRetried) {
      sessionStorage.setItem(reloadKey, 'true');
      window.location.reload();
      return new Promise(() => {});
    }

    throw error;
  }
};

export { isChunkLoadError };
export default lazyWithRetry;
